import { render, staticRenderFns } from "./LmProcessHistory.vue?vue&type=template&id=121460d3&scoped=true&"
import script from "./LmProcessHistory.vue?vue&type=script&lang=js&"
export * from "./LmProcessHistory.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessHistory.vue?vue&type=style&index=0&id=121460d3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121460d3",
  null
  
)

export default component.exports